"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _CustomButton = _interopRequireDefault(require("../../assets/Theme9/CustomButton.css"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _Contraction = _interopRequireDefault(require("../Contraction"));

var _FontColor = _interopRequireDefault(require("./FontColor"));

var _Level1Item = _interopRequireDefault(require("./Level1Item"));

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_CustomButton["default"]);

var Level1 = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Level1, _React$PureComponent);

  function Level1() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "onClickItem", function (item) {
      var handleClick = _this.props.handleClick;
      handleClick && handleClick(item);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLevel1", function (item) {
      if (item.type !== 0) return null;
      var language = _this.props.language;
      var menus = [].concat(item.children);
      var isOpen;
      var activityGroups = _this.props.activityGroups;

      if (activityGroups) {
        isOpen = activityGroups.indexOf(_this.props.index) > -1;
      } else {
        isOpen = _this.state.isOpen;
      } // menus.reverse();


      return /*#__PURE__*/_react["default"].createElement(_Contraction["default"], {
        isShow: isOpen
      }, menus.map(function (menu, i) {
        var title = (0, _utils.getLinkTitle)(menu, language);
        return /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
          ui: _this.props.ui,
          disableBgColor: true,
          disableColorHover: true,
          key: i
        }, /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
          onClick: _this.onClickItem.bind(_assertThisInitialized(_this), menu),
          vertical: "center",
          className: cx("ButtonTheme9Level2")
        }, /*#__PURE__*/_react["default"].createElement("div", null, title)));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          item = _this$props.item,
          index = _this$props.index,
          onClickGroup = _this$props.onClickGroup;

      if (item.type === 0) {
        var isOpen = _this.state.isOpen;

        _this.setState({
          isOpen: !isOpen
        });

        onClickGroup && onClickGroup(index);
      } else {
        var temp = item.children[0];

        _this.props.handleClick(temp);
      }
    });

    return _this;
  }

  var _proto = Level1.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        language = _this$props2.language,
        item = _this$props2.item,
        activityGroups = _this$props2.activityGroups;
    var isOpen;

    if (activityGroups) {
      isOpen = activityGroups.indexOf(this.props.index) > -1;
    } else {
      isOpen = this.state.isOpen;
    }

    console.log(3333444, this.props.ui);
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: 5
      }
    }, /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
      disableColorHover: true,
      ui: this.props.ui
    }, /*#__PURE__*/_react["default"].createElement(_Level1Item["default"], {
      onClick: this.onClick,
      item: item,
      language: language,
      isOpen: isOpen
    })), this.renderLevel1(item));
  };

  return Level1;
}(_react["default"].PureComponent);

var _default = Level1;
exports["default"] = _default;
module.exports = exports.default;